import { Anchor, Container, Group, Text } from "@mantine/core";
import { NewJerseySvg } from "./NewJerseySvg";
import classes from "./Footer.module.css";

export function Footer() {
  return (
    <footer className={classes.footer}>
      <Container fluid className={classes.inner}>
        <Text size="xs" c="dimmed">
          Powered by{" "}
          <Anchor href="https://mosaic.com" size="xs" c="dimmed" fw={600}>
            Mosaic
          </Anchor>
        </Text>
        <Group gap={4} justify="center">
          <Text size="xs" c="dimmed">
            Made with love in
          </Text>
          <NewJerseySvg
            width={12}
            height={18}
            style={{ color: "var(--mantine-color-dimmed)", verticalAlign: "middle" }}
            aria-label="New Jersey"
            role="img"
          />
        </Group>
        <Group gap="md">
          <Text size="xs" c="dimmed">
            &copy; {new Date().getFullYear()} Mosaic Sales Solutions
          </Text>
          <Anchor href="#" size="xs" c="dimmed" className={classes.link}>
            Privacy Policy
          </Anchor>
          <Anchor href="#" size="xs" c="dimmed" className={classes.link}>
            Terms of Use
          </Anchor>
        </Group>
      </Container>
    </footer>
  );
}
